<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">
                                    Remover workspace de cliente
                                </h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover o workspace
                                    <strong>{{ workspace.name }}</strong
                                    >? <br />
                                    <span
                                        >Esta ação não poderá ser
                                        desfeita.</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            workspace.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="workspaceNameConfirmation"
                                        id="confirmationInput"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    href="/customers/workspaces"
                                    class="btn btn"
                                    id="cancelAndBackButton"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    v-on:click="removeWorkspace"
                                    class="btn btn-danger"
                                    id="removeWorkspaceButton"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover a workspace
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "WorkspaceDeletePage",
    data() {
        return {
            workspaceNameConfirmation: "",
            workspace: {}
        }
    },
    async mounted() {
        var id = this.$route.params.id
        var response = await Api.customers.workspaces.get(id)
        this.workspace = response.data
    },
    methods: {
        async removeWorkspace() {
            var id = this.$route.params.id
            try {
                if (this.validate()) {
                    await Api.customers.workspaces.delete(id)

                    this.$router.push("/workspaces")

                    EventBus.emit("message", {
                        type: "success",
                        message: "Workspace removido com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover o workspace:" + error
                })
            }
        },
        validate() {
            if (this.workspace.name !== this.workspaceNameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message:
                        "O nome do workspace não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
